module.exports = __webpack_public_path__ + "img/xterra-surface-logo.c2e836ec.png";